export default __webpack_public_path__ + "static/media/apple_store_badge.8c4986ee.svg";